<template>


    <div>
        <include-exclude key="includexclude-1" :modelInclude.sync="queryForm.customer_groups_included"
            :modelExclude.sync="queryForm.customer_groups_excluded" data-label="customer-groups"
            :all-data="customerGroups" include-only />
        <include-exclude key="includexclude-2" :modelInclude.sync="queryForm.customer_segments_included"
            :modelExclude.sync="queryForm.customer_segments_excluded" data-label="customer-seqments"
            :all-data="customerSegments" include-only />
        <include-exclude key="includexclude-3" :modelInclude.sync="queryForm.customer_agents_included"
            :modelExclude.sync="queryForm.customer_agents_excluded" data-label="customer-agents"
            :all-data="customerAgents" include-only />
        <include-exclude key="includexclude-4" :modelInclude.sync="queryForm.lifecycle_stages_included"
            :modelExclude.sync="queryForm.lifecycle_stages_excluded" data-label="lifecycle-stages"
            :all-data="lifecycleStages" include-only />

        <IncludeExcludeAsync :modelInclude.sync="queryForm.customers_included" :key="`customer-${randomKey}`"
            :modelExclude.sync="queryForm.customers_excluded" data-label="customers" :queried-data="customers"
            @async-find="doCustomerSearch" @get-selected-data="getSelectedCustomers" :is-loading="loading"
            :selected-data="customerSelectedData" />

        <include-exclude key="includexclude-5" :modelInclude.sync="queryForm.order_types_included"
            :modelExclude.sync="queryForm.order_types_excluded" data-label="order-types" :all-data="orderTypes"
            include-only />

        <IncludeExcludeAsync :modelInclude.sync="queryForm.master_items_included" :key="`master-item-${randomKey}`"
            :modelExclude.sync="queryForm.master_items_excluded" data-label="master-items" :queried-data="masterItems"
            @async-find="doMasterItemSearch" @get-selected-data="getSelectedMasterItems" :is-loading="loading"
            :selected-data="masterItemSelectedData" include-only />

        <SlotContainer key="interaction-container" data-label="interaction">
            <template v-slot:header>
                <b-row>
                    <b-col class="px-1">
                        <b-form-checkbox id="input-are_dates_fixed" v-model="queryForm.are_dates_fixed">
                            &nbsp; {{ $translate('are_dates_fixed')
                            }}
                        </b-form-checkbox>
                    </b-col>
                    <b-col>
                        <b-form-checkbox id="input-contact_dob_only" v-model="queryForm.contact_dob_only">
                            &nbsp; {{ $translate('contact_dob_only')
                            }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </template>
            <template>
                <b-row class="gx-0 mb-4">
                    <b-col cols="12" md="4" class="dd px-2">
                        <b-form-group label-for="input-interaction_date_from"
                            :label="$translate('interaction_date_from')">

                            <div v-if="queryForm.are_dates_fixed" class="filter-date">
                                <input type="date" class="form-control" id="input-interaction_date_from"
                                    v-model="queryForm.interaction_date_from" />
                            </div>
                            <input v-else type="number" class="form-control" id="input-interaction_date_from"
                                v-model="queryForm.interaction_date_from" />
                        </b-form-group>

                    </b-col>
                    <b-col cols="12" md="4" class="dd px-2">
                        <b-form-group label-for="input-interaction_date_to" :label="$translate('interaction_date_to')">
                            <div v-if="queryForm.are_dates_fixed" class="filter-date">
                                <input type="date" class="form-control" v-if="queryForm.are_dates_fixed"
                                    id="input-interaction_date_to" v-model="queryForm.interaction_date_to" />
                            </div>

                            <input v-else type="number" class="form-control" id="input-interaction_date_to"
                                v-model="queryForm.interaction_date_to" />
                        </b-form-group>
                    </b-col>


                    <b-col cols="12" md="4" class="dd px-2">
                        <b-form-group label-for="input-contact_dob_advanced_hours"
                            :label="$translate('contact_dob_advanced_hours')">
                            <input type="number" class="form-control" id="input-contact_dob_advanced_hours" :max="48"
                                v-model="queryForm.contact_dob_advanced_hours" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
        </SlotContainer>
    </div>

</template>

<script>

import IncludeExclude from './IncludeExclude.vue';
import IncludeExcludeAsync from './IncludeExcludeAsync.vue';
import SlotContainer from './SlotContainer.vue';
import { debounce } from 'lodash'

const queryForm = Object.seal({
    customer_groups_included: [],
    customer_groups_excluded: [],

    customer_segments_included: [],
    customer_segments_excluded: [],

    customer_agents_included: [],
    customer_agents_excluded: [],

    lifecycle_stages_included: [],
    lifecycle_stages_excluded: [],

    customers_included: [],
    customers_excluded: [],

    order_types_included: [],
    order_types_excluded: [],

    master_items_included: [],
    master_items_excluded: [],

    interaction_date_from: null,
    interaction_date_to: null,
    are_dates_fixed: false,

    contact_dob_only: false,
    contact_dob_advanced_hours: null,
});


export default {
    name: 'orders-queryfilters',
    components: {
        IncludeExclude, IncludeExcludeAsync, SlotContainer
    },
    props: {
        value: {
            type: String,

        },
    },
    data() {
        return {
            loading: false,
            queryForm,
            customerSelectedData: [],
            masterItemSelectedData: [],
            randomKey: this.generateRandomKey(10)
        }
    },
    computed: {
        customerGroups() {
            return (this.$store.state.customerGroups.customer_groups || []).map(({ id, name }) => ({ id, name }))
        },

        customerSegments() {
            return (this.$store.state.customerSegments.customer_segments || []).map(({ id, name }) => ({ id, name }))
        },


        customerAgents() {
            return (this.$store.state.customerAgents.customer_agents || []).map(({ id, first_name, last_name }) => ({ id, name: `${first_name} ${last_name}` }))
        },


        lifecycleStages() {
            return (this.$store.state.lifecycleStage.items || []).map(({ id, name }) => ({ id, name }))
        },

        orderTypes() {
            return (this.$store.state.orderType.items || []).map(({ id, name }) => ({ id, name }))
        },

        masterItems() {
            return (this.$store.state.masterItem.items || []).map(({ id, name }) => ({ id, name }))
        },

        customers() {
            return (this.$store.state.customers.items || []).map(({ id, name }) => ({ id, name }))
        },
    },
    watch: {
        value: {
            handler: function (val) {
                let parsedObject = {};
                try {
                    const value = JSON.parse(val)
                    if (value != null && typeof value == 'object') {
                        for (const key in queryForm) {
                            parsedObject[key] = value[key];
                        }
                    }
                } catch (err) {
                    console.log("queryForm error:", err)
                }
                Object.assign(this.queryForm, parsedObject);
            },
            immediate: true
        }


    },

    methods: {
        getData() {
            return this.queryForm;
        },
        doMasterItemSearch: debounce(async function (query) {
            try {
                this.loading = true
                const page = 1;
                const filters = {}
                await this.$store.dispatch('masterItem/fetch', {
                    query,
                    page,
                    filters,
                })
            } catch (error) {
                console.error('loading error', error)
            } finally {
                this.loading = false
            }
        }, 500),

        doCustomerSearch: debounce(async function (query) {
            try {
                this.loading = true
                const page = 1;
                const filters = {}
                await this.$store.dispatch('customers/fetch', {
                    query,
                    page,
                    filters,
                })
            } catch (error) {
                console.error('loading error', error)
            } finally {
                this.loading = false
            }
        }, 500),
        getSelectedCustomers: debounce(async function (ids) {
            console.log("customer ids", ids)
            const data = await Promise.all(ids.map((id) => this.$store.dispatch('customers/fetchByIdFunction', id)));
            console.log("customer data:", data)
            this.customerSelectedData.length = 0;
            this.customerSelectedData.push(...data.map(({ id, name }) => ({ id, name })));
            this.randomKey = this.generateRandomKey(10);
        }),
        getSelectedMasterItems: debounce(async function (ids) {
            console.log("master ids", ids)
            const data = await Promise.all(ids.map((id) => this.$store.dispatch('masterItem/fetchByIdFunction', id)));
            console.log("master data:", data)
            this.masterItemSelectedData.length = 0;
            this.masterItemSelectedData.push(...data.map(({ id, name, order_item_type_id }) => ({ id, name, order_item_type_id })));
            this.randomKey = this.generateRandomKey(10);
        }),
        generateRandomKey(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        }
    },
}
</script>
